<template>
  <StampaDesktop v-if="!$vuetify.breakpoint.mobile" />
  <StampaMobile v-else />
</template>

<script>
import StampaDesktop from "@/components/Stampa/desktop/stampa_desktop.vue";
import StampaMobile from "@/components/Stampa/mobile/stampa_mobile.vue";
export default {
  name: "Stampa",
  components: {
    StampaDesktop,
    StampaMobile,
  },
};
</script>
